import { render, staticRenderFns } from "./Elements.vue?vue&type=template&id=650dc978"
import script from "./Elements.vue?vue&type=script&lang=ts"
export * from "./Elements.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports